<div class="tandij ion-padding">
  <div class="td-nincs" *ngIf="allapot && !allapot.aktiv">
    <ion-icon name="link-outline"></ion-icon>
    <strong>A támogatási egyenleg nincs bekapcsolva.</strong>
    <span>A Könyvelés (NAPLO) ügyfélbeállításában ki kell választani a SULINFORM-intézményt és a támogatási bankszámlát.</span>
  </div>

  <ng-container *ngIf="allapot?.aktiv">
    <div class="td-fej">
      <label class="td-tanev">Tanév
        <select [(ngModel)]="tanev" (ngModelChange)="frissit()">
          <option *ngFor="let t of tanevek" [ngValue]="t">{{ tanevNev(t) }}</option>
        </select>
      </label>
      <ion-segment *ngIf="!csaladiNezet" [value]="nezet" (ionChange)="nezetValt($any($event).detail.value)" class="td-szegmens">
        <ion-segment-button value="egyenlegek"><ion-label>Egyenlegek</ion-label></ion-segment-button>
        <ion-segment-button value="osszerendeles"><ion-label>Bankpartnerek</ion-label></ion-segment-button>
        <ion-segment-button value="kiiras"><ion-label>Éves kiírás</ion-label></ion-segment-button>
        <ion-segment-button value="egyeb"><ion-label>Egyéb bevételek</ion-label></ion-segment-button>
      </ion-segment>
      <span class="td-szamla" *ngIf="allapot.iban">{{ allapot.ugyfel_nev }} · {{ allapot.iban }}</span>
    </div>

    <div class="td-hiba" *ngIf="hiba">{{ hiba }}</div>
    <div class="td-uzenet" *ngIf="uzenet">{{ uzenet }}</div>
    <ion-progress-bar type="indeterminate" *ngIf="betolt"></ion-progress-bar>

    <!-- ═══ CSALÁD ═══ -->
    <ng-container *ngIf="csaladiNezet && sajat">
      <div class="td-nincs" *ngIf="!sajat.csaladok?.length">
        <ion-icon name="information-circle-outline"></ion-icon>
        <span>Erre a tanévre nincs támogatási kiírás a családotokhoz.</span>
      </div>
      <div class="td-kartya" *ngFor="let c of sajat.csaladok">
        <div class="td-kartya-fej">
          <div>
            <div class="td-cim">{{ c.nev }}</div>
            <div class="td-al">{{ tanevNev(tanev) }} tanév · {{ c.gyerekek.length }} gyermek</div>
          </div>
          <ion-badge [color]="c.egyenleg > 0 ? 'warning' : 'success'">
            {{ c.egyenleg > 0 ? 'Hátralék: ' + ft(c.egyenleg) + ' Ft' : (c.egyenleg < 0 ? 'Túlfizetés: ' + ft(-c.egyenleg) + ' Ft' : 'Rendezve') }}
          </ion-badge>
        </div>
        <div class="td-zseb-cim" *ngIf="c.zsebek?.length">{{ sajat.fo_zseb }}</div>
        <div class="td-szamok">
          <div><span>Éves támogatás</span><b>{{ ft(c.kiirt) }} Ft</b></div>
          <div><span>Befizetve</span><b>{{ ft(c.befizetett) }} Ft</b></div>
          <div><span>Hátralévő</span><b>{{ ft(c.egyenleg > 0 ? c.egyenleg : 0) }} Ft</b></div>
        </div>
        <!-- A kiírás megjegyzése (pl. testvérkedvezmény) – a családnak szól, jól láthatóan. -->
        <div class="td-megjegyzes" *ngIf="c.megjegyzes"><ion-icon name="information-circle-outline"></ion-icon><span><b>Megjegyzés:</b> {{ c.megjegyzes }}</span></div>
        <div class="td-sav"><div [style.width.%]="c.kiirt > 0 ? (c.befizetett / c.kiirt * 100) : 0"></div></div>
        <!-- További zsebek (pl. Zenit Start): mindegyik a saját kiírásával és befizetéseivel. -->
        <ng-container *ngFor="let z of c.zsebek">
          <div class="td-zseb-cim">{{ z.nev }}</div>
          <div class="td-szamok">
            <div><span>Kiírva</span><b>{{ ft(z.kiirt) }} Ft</b></div>
            <div><span>Befizetve</span><b>{{ ft(z.befizetett) }} Ft</b></div>
            <div><span>Hátralévő</span><b>{{ ft(z.egyenleg > 0 ? z.egyenleg : 0) }} Ft</b></div>
          </div>
          <div class="td-megjegyzes" *ngIf="z.megjegyzes"><ion-icon name="information-circle-outline"></ion-icon><span><b>Megjegyzés:</b> {{ z.megjegyzes }}</span></div>
          <div class="td-sav"><div [style.width.%]="z.kiirt > 0 ? (z.befizetett / z.kiirt * 100) : 0"></div></div>
        </ng-container>
        <table class="td-tabla" *ngIf="c.befizetesek.length">
          <tr><th>Dátum</th><th>Befizető</th><th>Közlemény</th><th *ngIf="c.zsebek?.length">Zseb</th><th class="sz">Összeg</th><th></th></tr>
          <tr *ngFor="let b of c.befizetesek">
            <td>{{ b.datum }}</td><td>{{ b.partner_nev }}</td><td class="km">{{ b.kozlemeny }}</td>
            <td *ngIf="c.zsebek?.length">{{ b.zseb_nev }}</td><td class="sz">{{ ft(b.osszeg) }} Ft</td>
            <td><ion-button *ngIf="b.bizonylat_id" fill="clear" size="small" (click)="bizonylatNyit(b)" [title]="'Bizonylat: ' + b.bizonylat_szam">
              <ion-icon name="document-text-outline"></ion-icon></ion-button></td>
          </tr>
        </table>
        <div class="td-al" *ngIf="!c.befizetesek.length">Ebben a tanévben még nem érkezett támogatási befizetés.</div>
      </div>
      <div class="td-al td-lab" *ngIf="sajat.iban">Utalás: {{ sajat.kedvezmenyezett }} · {{ sajat.iban }}. A befizetés a bank napi szinkronja után jelenik meg.</div>
    </ng-container>

    <!-- ═══ KEZELŐ: EGYENLEGEK ═══ -->
    <ng-container *ngIf="!csaladiNezet && nezet === 'egyenlegek' && egyenlegek">
      <div class="td-osszeg">
        <div><span>Kiírva</span><b>{{ ft(egyenlegek.osszesen.kiirt) }} Ft</b></div>
        <div><span>Befizetve</span><b>{{ ft(egyenlegek.osszesen.befizetett) }} Ft</b></div>
        <div><span>Hátralék</span><b>{{ ft(egyenlegek.osszesen.hatralek) }} Ft</b></div>
        <div *ngFor="let z of egyenlegek.zsebek" class="td-zseb-doboz"><span>{{ z.nev }}</span>
          <b>{{ ft(egyenlegek.zseb_osszesen[z.id]?.befizetett) }} / {{ ft(egyenlegek.zseb_osszesen[z.id]?.kiirt) }} Ft</b>
          <small>hátralék: {{ ft(egyenlegek.zseb_osszesen[z.id]?.hatralek) }} Ft</small></div>
        <div class="kattinthato" (click)="nezetValt('egyeb')"><span>Normatíva, adomány, egyéb</span>
          <b>{{ egyenlegek.osszesen.egyeb_db }} db · {{ ft(egyenlegek.osszesen.egyeb_osszeg) }} Ft</b></div>
        <div class="kattinthato" (click)="nezetValt('osszerendeles')"><span>Hozzá nem rendelt jóváírás</span>
          <b>{{ egyenlegek.osszesen.nem_rendelt_db }} db · {{ ft(egyenlegek.osszesen.nem_rendelt_osszeg) }} Ft</b></div>
      </div>
      <div class="td-szuro">
        <input type="search" [(ngModel)]="kereses" placeholder="Keresés: név, szülő, osztály…">
        <label><input type="checkbox" [(ngModel)]="csakHatralek"> csak hátralékos</label>
        <label><input type="checkbox" [(ngModel)]="csakLeendo"> csak leendő (még be nem iratkozott)</label>
        <span class="td-al">{{ szurtCsaladok.length }} család</span>
      </div>
      <div class="td-ket-oszlop">
        <table class="td-tabla td-lista">
          <tr *ngIf="egyenlegek.zsebek?.length" class="td-fejcsoport">
            <th colspan="2"></th><th colspan="3" class="kozep">{{ egyenlegek.fo_zseb }}</th>
            <th *ngFor="let z of egyenlegek.zsebek" class="kozep">{{ z.nev }}</th><th></th></tr>
          <tr><th>Család</th><th>Osztály</th><th class="sz">Kiírva</th><th class="sz">Befizetve</th><th class="sz">Egyenleg</th>
            <th *ngFor="let z of egyenlegek.zsebek" class="sz" title="Egyenleg (befizetve / kiírva)">Egyenleg</th><th></th></tr>
          <tr *ngFor="let c of szurtCsaladok" (click)="reszletNyit(c.csalad)" [class.kivalasztott]="reszlet?.csalad === c.csalad">
            <td><b>{{ c.nev }}</b><span class="td-leendo" *ngIf="c.leendo" title="Még be nem iratkozott család (pl. Zenit Start)">leendő</span><div class="td-al">{{ c.szulok.join(', ') }}</div></td>
            <td>{{ osztalyok(c) }}</td>
            <td class="sz">{{ c.kiirt ? ft(c.kiirt) : '–' }}</td>
            <td class="sz">{{ ft(c.befizetett) }}</td>
            <td class="sz" [class.piros]="c.egyenleg > 0" [class.zold]="c.kiirt && c.egyenleg <= 0">{{ ft(c.egyenleg) }}</td>
            <td *ngFor="let z of egyenlegek.zsebek" class="sz" [class.piros]="c.zsebek[z.id]?.egyenleg > 0" [class.zold]="c.zsebek[z.id]?.kiirt && c.zsebek[z.id]?.egyenleg <= 0">
              <ng-container *ngIf="c.zsebek[z.id]?.kiirt || c.zsebek[z.id]?.befizetett; else nincsZseb">{{ ft(c.zsebek[z.id].egyenleg) }}
                <div class="td-al">{{ ft(c.zsebek[z.id].befizetett) }} / {{ ft(c.zsebek[z.id].kiirt) }}</div></ng-container>
              <ng-template #nincsZseb>–</ng-template></td>
            <td><ion-icon name="link-outline" *ngIf="c.partner_db" [title]="c.partner_db + ' bankpartner'"></ion-icon></td>
          </tr>
        </table>
        <div class="td-reszlet" *ngIf="reszlet">
          <div class="td-kartya-fej">
            <div><div class="td-cim">{{ reszlet.nev }}</div><div class="td-al">{{ reszlet.szulok?.join(', ') }}</div></div>
            <ion-button fill="clear" size="small" (click)="reszlet = null"><ion-icon name="close"></ion-icon></ion-button>
          </div>
          <div class="td-zseb-cim" *ngIf="reszlet.zseb_lista?.length">{{ reszlet.fo_zseb }}</div>
          <div class="td-szamok">
            <div><span>Kiírva</span><b>{{ ft(reszlet.kiirt) }}</b></div>
            <div><span>Befizetve</span><b>{{ ft(reszlet.befizetett) }}</b></div>
            <div><span>Egyenleg</span><b>{{ ft(reszlet.egyenleg) }}</b></div>
          </div>
          <ng-container *ngFor="let z of reszlet.zseb_lista">
            <div class="td-zseb-cim">{{ z.nev }}</div>
            <div class="td-szamok">
              <div><span>Kiírva</span><b>{{ ft(reszlet.zsebek[z.id]?.kiirt) }}</b></div>
              <div><span>Befizetve</span><b>{{ ft(reszlet.zsebek[z.id]?.befizetett) }}</b></div>
              <div><span>Egyenleg</span><b>{{ ft(reszlet.zsebek[z.id]?.egyenleg) }}</b></div>
            </div>
          </ng-container>
          <!-- LEENDŐ CSALÁD: még be nem iratkozott (pl. Zenit Start); beiratkozáskor összevonható. -->
          <div class="td-leendo-blokk" *ngIf="reszlet.leendo">
            <div class="td-al">Még be nem iratkozott család – a gyerek(ek) nincsenek a nyilvántartásban. Beiratkozáskor vond össze a KRÉTÁ-ból érkező családdal (vagy a testvér meglévő családjával): a befizetők, a befizetések és a bizonylatok átkerülnek.</div>
            <div *ngIf="reszlet.megjegyzes" class="td-al">Megjegyzés: {{ reszlet.megjegyzes }}</div>
            <ng-container *ngIf="!leendoSzerk">
              <div class="td-leendo-gombok">
                <ion-button size="small" fill="outline" (click)="leendoSzerkNyit()"><ion-icon slot="start" name="create-outline"></ion-icon>Adatok</ion-button>
                <ion-button size="small" fill="clear" color="danger" (click)="leendoTorol()" [disabled]="reszlet.partnerek?.length"
                            title="Csak akkor törölhető, ha nincs hozzá rendelve semmi"><ion-icon slot="start" name="trash-outline"></ion-icon>Törlés</ion-button>
              </div>
              <div class="td-leendo-osszevon">
                <select [(ngModel)]="osszevonCel">
                  <option value="">— összevonás beiratkozott családdal —</option>
                  <option *ngFor="let c of valodiCsaladok" [value]="c.csalad">{{ c.nev }}{{ osztalyok(c) ? ' (' + osztalyok(c) + ')' : '' }}</option>
                </select>
                <ion-button size="small" (click)="leendoOsszevon()" [disabled]="!osszevonCel">Összevonás</ion-button>
              </div>
            </ng-container>
            <div class="td-leendo-szerk" *ngIf="leendoSzerk">
              <ion-input label="Család neve" labelPlacement="stacked" fill="outline" [(ngModel)]="leendoSzerk.nev"></ion-input>
              <ion-input label="Gyerek(ek), vesszővel" labelPlacement="stacked" fill="outline" [(ngModel)]="leendoSzerk.gyerekek"></ion-input>
              <ion-input label="Szülő(k), pontosvesszővel" labelPlacement="stacked" fill="outline" [(ngModel)]="leendoSzerk.szulok"></ion-input>
              <ion-input label="Megjegyzés" labelPlacement="stacked" fill="outline" maxlength="255" [(ngModel)]="leendoSzerk.megjegyzes"></ion-input>
              <div class="td-leendo-gombok">
                <ion-button size="small" fill="clear" (click)="leendoSzerk = null">Mégse</ion-button>
                <ion-button size="small" (click)="leendoMent()">Mentés</ion-button>
              </div>
            </div>
          </div>
          <h4>Bankpartnerek</h4>
          <div class="td-al" *ngIf="!reszlet.partnerek?.length">Nincs hozzárendelt bankpartner – a Bankpartnerek nézetben lehet hozzárendelni.</div>
          <div class="td-partner" *ngFor="let p of reszlet.partnerek">
            <span>{{ p.partner_nev }} <small>{{ p.partner_szamla }}</small></span>
            <ion-button fill="clear" size="small" color="danger" (click)="partnerTorol(p)" title="Összerendelés törlése"><ion-icon name="unlink-outline"></ion-icon></ion-button>
          </div>
          <h4>Befizetések ({{ tanevNev(tanev) }})
            <ion-button fill="clear" size="small" (click)="bizonylatGeneral()" [disabled]="bizFut" title="A hiányzó számviteli bizonylatok elkészítése most">
              <ion-icon slot="start" name="document-text-outline"></ion-icon>{{ bizFut ? 'Bizonylatok…' : 'Bizonylatok generálása' }}</ion-button>
          </h4>
          <table class="td-tabla">
            <tr *ngFor="let b of reszlet.befizetesek" [class.kizart]="b.kizarva">
              <td>{{ b.datum }}</td><td>{{ b.partner_nev }}<div class="td-al">{{ b.kozlemeny }}<span *ngIf="b.kezi && b.rogzitette"> · rögzítette: {{ b.rogzitette }}</span>
                <span *ngIf="b.atsorolva != null"> · a {{ tanevNev(b.atsorolva) }} tanévhez sorolva</span></div>
                <select *ngIf="reszlet.zseb_lista?.length && !b.kizarva" class="td-zseb-valaszto" [ngModel]="zsebErtek(b)" (ngModelChange)="zsebBesorol(b, $event)"
                        title="Melyik zsebbe számít ez a befizetés">
                  <option value="auto" *ngIf="!b.kezi">Közlemény szerint{{ b.zseb_kezi ? '' : ' → ' + zsebNev(b.zseb) }}</option>
                  <option [value]="'k:'">{{ reszlet.fo_zseb }}</option>
                  <option *ngFor="let z of reszlet.zseb_lista" [value]="'k:' + z.id">{{ z.nev }}</option>
                </select></td>
              <td class="sz">{{ ft(b.osszeg) }}</td>
              <td>
                <ion-button fill="clear" size="small" (click)="tanevAtsorol(b)" title="Másik tanévhez sorolás (pl. előre fizetés)">
                  <ion-icon name="calendar-outline"></ion-icon></ion-button>
                <ion-button *ngIf="b.bizonylat_id" fill="clear" size="small" (click)="bizonylatNyit(b)" [title]="'Számviteli bizonylat: ' + b.bizonylat_szam">
                  <ion-icon name="document-text-outline"></ion-icon></ion-button>
                <ion-button *ngIf="!b.kezi" fill="clear" size="small" (click)="kizar(b)" [title]="b.kizarva ? 'Visszavétel támogatásnak (' + b.kizarva_ok + ')' : 'Nem támogatás – kizárás'">
                  <ion-icon [name]="b.kizarva ? 'arrow-undo-outline' : 'remove-circle-outline'"></ion-icon></ion-button>
                <ion-button *ngIf="b.kezi" fill="clear" size="small" color="danger" (click)="keziTorol(b)" title="Kézi befizetés törlése (téves rögzítés)">
                  <ion-icon name="trash-outline"></ion-icon></ion-button>
              </td>
            </tr>
          </table>
          <!-- KÉZI BEFIZETÉS: ami nem bankon át jön (pl. készpénz a titkárságon). -->
          <h4>Kézi befizetés (pl. készpénz)</h4>
          <div class="td-kezi">
            <ion-input type="date" label="Dátum" labelPlacement="stacked" fill="outline" [(ngModel)]="kezi.datum"></ion-input>
            <ion-input type="number" label="Összeg (Ft)" labelPlacement="stacked" fill="outline" min="1" [(ngModel)]="kezi.osszeg"></ion-input>
            <ion-select label="Mód" labelPlacement="stacked" fill="outline" interface="popover" [(ngModel)]="kezi.mod">
              <ion-select-option value="keszpenz">Készpénz</ion-select-option>
              <ion-select-option value="egyeb">Egyéb</ion-select-option>
            </ion-select>
            <ion-select *ngIf="reszlet.zseb_lista?.length" label="Zseb" labelPlacement="stacked" fill="outline" interface="popover" [(ngModel)]="kezi.zseb">
              <ion-select-option value="">{{ reszlet.fo_zseb }}</ion-select-option>
              <ion-select-option *ngFor="let z of reszlet.zseb_lista" [value]="z.id">{{ z.nev }}</ion-select-option>
            </ion-select>
            <ion-input label="Megjegyzés (pl. nyugtaszám)" labelPlacement="stacked" fill="outline" maxlength="255" [(ngModel)]="kezi.megjegyzes"></ion-input>
            <ion-button size="small" (click)="keziRogzit()" [disabled]="keziFut || !(kezi.osszeg > 0) || !kezi.datum">
              <ion-icon slot="start" name="add-circle-outline"></ion-icon>Rögzítés
            </ion-button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ═══ KEZELŐ: BANKPARTNEREK ═══ -->
    <ng-container *ngIf="!csaladiNezet && nezet === 'osszerendeles' && partnerek">
      <div class="td-szuro">
        <input type="search" [(ngModel)]="partnerKereses" placeholder="Keresés: név, számlaszám, közlemény…">
        <label><input type="checkbox" [(ngModel)]="csakRendeletlen"> csak a még be nem soroltak</label>
        <ion-button size="small" *ngIf="javaslatDb" (click)="javaslatokElfogadasa()">
          <ion-icon slot="start" name="sparkles-outline"></ion-icon>{{ javaslatDb }} javaslat elfogadása
        </ion-button>
        <ion-button size="small" fill="outline" (click)="leendoJavaslatBetolt()" [disabled]="leendoFut"
                    title="A még be nem iratkozott családok (pl. Zenit Start) felvétele a befizetőkből, a közleményben szereplő gyereknévvel">
          <ion-icon slot="start" name="people-outline"></ion-icon>Leendő családok a befizetőkből
        </ion-button>
      </div>
      <!-- LEENDŐ CSALÁDOK JAVASLATA: a fő zsebtől eltérő zsebbe (pl. Zenit Start) fizető, sehova nem rendelt befizetők. -->
      <div class="td-leendo-javaslat" *ngIf="leendoJavaslatok">
        <div class="td-kartya-fej">
          <div><div class="td-cim">Leendő családok – javaslat</div>
            <div class="td-al">A sehova nem rendelt befizetők, akik nem a támogatási díjba fizettek (pl. Zenit Start). A gyerek nevét a közleményből olvastuk ki – javítsd, ha kell. Ugyanaz a befizető egy család; több gyereknél vesszővel.</div></div>
          <ion-button fill="clear" size="small" (click)="leendoJavaslatok = null"><ion-icon name="close"></ion-icon></ion-button>
        </div>
        <div class="td-al" *ngIf="!leendoJavaslatok.length">Nincs ilyen befizető – mindenki hozzá van rendelve valahová.</div>
        <table class="td-tabla" *ngIf="leendoJavaslatok.length">
          <tr><th></th><th>Befizető</th><th>Közlemény</th><th class="sz">Befizetve</th><th>Család neve</th><th>Gyerek(ek)</th></tr>
          <tr *ngFor="let j of leendoJavaslatok">
            <td><input type="checkbox" [(ngModel)]="j.kell"></td>
            <td><b>{{ j.partner_nev }}</b><div class="td-al">{{ j.zsebek.join(', ') }}</div></td>
            <td class="km">{{ j.kozlemenyek.join(' · ') }}</td>
            <td class="sz">{{ j.db }} db<br><b>{{ ft(j.osszeg) }}</b></td>
            <td><input class="td-szoveg" [(ngModel)]="j.nev"></td>
            <td><input class="td-szoveg" [(ngModel)]="j.gyerekSzoveg" placeholder="(nincs a közleményben)"></td>
          </tr>
        </table>
        <div class="td-leendo-gombok" *ngIf="leendoJavaslatok.length">
          <ion-button size="small" (click)="leendoJavaslatFelvetel()" [disabled]="leendoFut || !leendoKijeloltDb">
            <ion-icon slot="start" name="add-circle-outline"></ion-icon>{{ leendoKijeloltDb }} leendő család felvétele és a befizető hozzárendelése
          </ion-button>
        </div>
      </div>
      <div class="td-al td-lab">A támogatási számlára a tanévben érkezett jóváírások küldőnként. Hozzárendelés után a küldő minden jóváírása a családé (a számlaszám azonosít, ennek híján a név). A normatívát, az adományt, az 1%-ot és az egyéb nem támogatási bevételt kategóriához rendeld: ezek nem számítanak egyik család egyenlegébe sem, és az „Egyéb bevételek” nézetben külön látszanak.</div>
      <table class="td-tabla">
        <tr><th>Befizető</th><th>Közlemények</th><th class="sz">Jóváírás</th><th>Család</th><th></th></tr>
        <tr *ngFor="let p of szurtPartnerek">
          <td><b>{{ p.partner_nev || '(név nélkül)' }}</b><div class="td-al">{{ p.partner_szamla }}</div></td>
          <td class="km">{{ p.kozlemenyek.join(' · ') }}</td>
          <td class="sz">{{ p.db }} db<br><b>{{ ft(p.osszeg) }}</b></td>
          <td>
            <span *ngIf="p.csalad" class="zold">{{ p.csalad_nev }}</span>
            <span *ngIf="p.kategoria" class="td-kat">{{ p.kategoria_nev }}</span>
            <select *ngIf="!p.csalad && !p.kategoria" [(ngModel)]="valasztas[p.kulcs]">
              <option [ngValue]="undefined">— válassz családot vagy kategóriát —</option>
              <optgroup label="Nem támogatás (nem számít családhoz)">
                <option *ngFor="let k of kategoriaLista" [ngValue]="'kat:' + k.kod">{{ k.nev }}</option>
              </optgroup>
              <optgroup label="Család">
                <option *ngFor="let c of beiratkozottCsaladokPartnerhez" [ngValue]="c.csalad">{{ c.nev }}{{ c.osztalyok.length ? ' (' + c.osztalyok.join(', ') + ')' : '' }}</option>
              </optgroup>
              <optgroup label="Leendő család (még nem iratkozott be)">
                <option *ngFor="let c of leendoCsaladokPartnerhez" [ngValue]="c.csalad">{{ c.nev }}</option>
                <option [ngValue]="'uj-leendo'">+ új leendő család ebből a befizetőből…</option>
              </optgroup>
            </select>
            <div class="td-al" *ngIf="!p.csalad && !p.kategoria && p.javaslat">Javaslat névegyezés alapján: {{ p.javaslat_nev }}</div>
            <div class="td-al" *ngIf="!p.csalad && !p.kategoria && p.javaslat_kategoria">Javaslat a küldő/közlemény alapján: {{ partnerek.kategoriak[p.javaslat_kategoria] }}</div>
          </td>
          <td>
            <ion-button size="small" *ngIf="!p.csalad && !p.kategoria" [disabled]="!valasztas[p.kulcs]" (click)="hozzarendel(p)">Hozzárendel</ion-button>
            <ion-button size="small" fill="clear" color="danger" *ngIf="p.partner_id" (click)="partnerTorol({ id: p.partner_id })" title="Hozzárendelés törlése">
              <ion-icon slot="start" name="unlink-outline"></ion-icon>Törlés</ion-button>
          </td>
        </tr>
      </table>
    </ng-container>

    <!-- ═══ KEZELŐ: ÉVES KIÍRÁS ═══ -->
    <ng-container *ngIf="!csaladiNezet && nezet === 'kiiras' && egyenlegek">
      <!-- ZSEBEK: a támogatási díj mellett további gyűjtők, saját kiírással és egyenleggel. -->
      <div class="td-kartya td-zsebek">
        <div class="td-kartya-fej"><div><div class="td-cim">Zsebek</div>
          <div class="td-al">A fő zseb a(z) „{{ foZseb }}”. A további zsebekre külön lehet kiírni, és mindegyik saját oszlopot kap. A banki befizetés abba a zsebbe kerül, amelynek valamelyik kulcsszava szerepel a közleményben (pl. „zenit start”); egyébként a(z) {{ foZseb }} zsebbe. A család részleteinél tételenként át is írható.</div></div></div>
        <div class="td-zseb-sor" *ngFor="let z of zsebSzerk">
          <input type="text" maxlength="100" [(ngModel)]="z.nev" placeholder="Zseb neve">
          <input type="text" maxlength="500" [(ngModel)]="z.kulcsszavak" placeholder="Közlemény-kulcsszavak, vesszővel (pl. zenit start, zenitstart)">
          <ion-button size="small" fill="outline" (click)="zsebMent(z)" [disabled]="zsebFut">Mentés</ion-button>
          <ion-button size="small" fill="clear" color="danger" (click)="zsebTorol(z)" [disabled]="zsebFut" title="Zseb törlése"><ion-icon name="trash-outline"></ion-icon></ion-button>
        </div>
        <div class="td-zseb-sor">
          <input type="text" maxlength="100" [(ngModel)]="ujZseb.nev" placeholder="Új zseb neve (pl. Zenit Start)">
          <input type="text" maxlength="500" [(ngModel)]="ujZseb.kulcsszavak" placeholder="Közlemény-kulcsszavak, vesszővel">
          <ion-button size="small" (click)="zsebMent(ujZseb)" [disabled]="zsebFut || !ujZseb.nev.trim()"><ion-icon slot="start" name="add-circle-outline"></ion-icon>Új zseb</ion-button>
        </div>
      </div>
      <div class="td-szuro">
        <select *ngIf="zsebek.length" [(ngModel)]="kiirasCel" title="Melyik zseb oszlopára alkalmazza">
          <option value="">{{ foZseb }}</option>
          <option *ngFor="let z of zsebek" [value]="z.id">{{ z.nev }}</option>
        </select>
        <select [(ngModel)]="kiirasMod">
          <option value="gyermek">Összeg gyermekenként</option>
          <option value="csalad">Összeg családonként</option>
        </select>
        <input type="number" min="0" step="1000" [(ngModel)]="kiirasAlap" placeholder="Éves összeg (Ft)">
        <ion-button size="small" fill="outline" (click)="alapAlkalmaz()" [disabled]="!kiirasAlap">Mindenkire alkalmaz</ion-button>
        <span class="td-al">Összesen: <b>{{ ft(kiirasOsszeg) }} Ft</b></span>
        <ion-button size="small" (click)="kiirasMentes()" [disabled]="kiirasMent">Kiírás mentése</ion-button>
      </div>
      <div class="td-al td-lab">A {{ tanevNev(tanev) }} tanév egész évre szóló befizetendője családonként<span *ngIf="zsebek.length"> és zsebenként</span>. A sor összege külön is átírható (pl. kedvezmény); a 0 vagy üres összeg törli a kiírást. Gyermekenkénti összegnél csak a most is jogviszonyban álló gyermekek számítanak.<span *ngIf="zsebek.length"> A „Mindenkire alkalmaz” a bal oldalt kiválasztott zseb oszlopát tölti.</span></div>
      <table class="td-tabla">
        <tr><th>Család</th><th>Osztály</th><th class="sz">Gyermek</th><th class="sz">Eddigi</th><th class="sz">{{ zsebek.length ? foZseb : 'Éves támogatás' }} (Ft)</th>
          <th *ngFor="let z of zsebek" class="sz">{{ z.nev }} (Ft)<div class="td-al">{{ ft(kiirasOszlopOsszeg(z.id)) }}</div></th><th>Megjegyzés</th></tr>
        <tr *ngFor="let s of kiirasSorok">
          <td>{{ s.nev }}</td><td>{{ s.osztalyok }}</td><td class="sz">{{ s.gyerek_db }}</td>
          <td class="sz">{{ s.regi !== null ? ft(s.regi) : '–' }}</td>
          <td class="sz"><input type="number" min="0" step="1000" [(ngModel)]="s.osszeg"></td>
          <td *ngFor="let z of zsebek" class="sz"><input type="number" min="0" step="1000" [(ngModel)]="s.zs[z.id].osszeg"
            [title]="s.zs[z.id].regi !== null ? 'Eddigi: ' + ft(s.zs[z.id].regi) + ' Ft' : 'Még nincs kiírva'"></td>
          <td><input type="text" maxlength="255" [(ngModel)]="s.megjegyzes" placeholder="pl. testvérkedvezmény"></td>
        </tr>
      </table>
    </ng-container>

    <!-- ═══ KEZELŐ: EGYÉB BEVÉTELEK (normatíva, adomány, egyéb) ═══ -->
    <ng-container *ngIf="!csaladiNezet && nezet === 'egyeb' && egyeb">
      <div class="td-al td-lab">A támogatási számla nem támogatási jóváírásai a {{ tanevNev(tanev) }} tanévben ({{ egyeb.ablak.tol }} – {{ egyeb.ablak.ig }}). Ide a Bankpartnerek nézetben kategóriához rendelt küldők utalásai kerülnek.</div>
      <div class="td-osszeg">
        <div *ngFor="let k of egyeb.kategoriak" [class.td-normativa]="k.kod === 'normativa'"><span>{{ k.nev }}</span><b>{{ ft(k.osszeg) }} Ft</b><small>{{ k.db }} tétel</small></div>
        <div class="kattinthato" (click)="nezetValt('osszerendeles')"><span>{{ egyeb.besorolatlan.nev }}</span><b>{{ ft(egyeb.besorolatlan.osszeg) }} Ft</b><small>{{ egyeb.besorolatlan.db }} tétel</small></div>
      </div>
      <ng-container *ngFor="let k of egyebCsoportok">
        <div class="td-kartya" *ngIf="k.db">
          <div class="td-kartya-fej">
            <div class="td-cim">{{ k.nev }}</div>
            <b>{{ ft(k.osszeg) }} Ft</b>
          </div>
          <div class="td-honapok">
            <span *ngFor="let h of honapLista(k)">{{ h.honap }}: <b>{{ ft(h.osszeg) }}</b></span>
          </div>
          <table class="td-tabla">
            <tr><th>Dátum</th><th>Küldő</th><th>Közlemény</th><th class="sz">Összeg</th></tr>
            <tr *ngFor="let t of k.tetelek">
              <td>{{ t.datum }}</td><td>{{ t.partner_nev }}<div class="td-al">{{ t.partner_szamla }}</div></td>
              <td class="km">{{ t.kozlemeny }}<div class="td-al" *ngIf="t.kizarva_ok">kizárva: {{ t.kizarva_ok }}</div></td>
              <td class="sz">{{ ft(t.osszeg) }} Ft</td>
            </tr>
          </table>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
